export const products = {
  MSRP: "MSRP",
  LogInForPricing: "Log in for pricing",
  FilledOnSite: "Filled on-site",
  OnlyOnFullscript: "Only on Fullscript",
  PillPacksTooltip:
    "Daily packs are personalized to include both you and your practitioner’s names on the package.",
  Unit: "/ unit",
} as const;
